import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {BettingPromotionModuleTerms} from "./betting-promotion.module.terms";

export class BettingPromotionModuleConfig extends BaseConfig {

  static injectables = [BettingPromotionModuleTerms];

  constructor(terms: BettingPromotionModuleTerms) {
    super('bettingPromotionModule', null, terms);
  }
}
